import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStellarComponent } from './simple-icons-stellar.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStellarComponent ],
    exports:      [ SimpleIconsStellarComponent ],
    bootstrap:    []
})
export class SimpleIconsStellarModule {}
